import { useEffect } from "react";
import { shallowEqual } from "react-redux";
import { setInsuranceQuote } from "../redux/actions/UscInsuranceActions";
import Debug from "../../../common-deprecated/Debug";
import { getInsuranceQuoteFromStorage, getSessionStorageParams } from "../utils/sessionStorage";
import type { UscInsuranceQuoteType } from "../utils/insuranceUtils";
import { type UscActionsType, type UscStateType, useUscSelector } from "../redux/store";
import { useStore } from "../../../shared-logic/redux/store";

const useUscInsuranceInit = (): void => {
    const { dispatch } = useStore<UscStateType, UscActionsType>();
    const { country } = useUscSelector((state) => state.commonSettings);
    const { insuranceGatewayUrl } = useUscSelector((state) => state.uscSettings);
    const vehicleState = useUscSelector((state) => state.vehicle);

    const insuranceQuoteId = useUscSelector((state) => state.insurance.insuranceQuoteId);
    const sessionStorageParmms = useUscSelector(getSessionStorageParams, shallowEqual);

    const vehicleLoaded = !!vehicleState.result;
    useEffect(() => {
        if (!vehicleLoaded) return;

        if (insuranceQuoteId) {
            // tyCode contained insuranceQuote, fetch from makolab.
            const fetchInsuranceQuote = async (): Promise<void> => {
                try {
                    const result = await fetch(`${insuranceGatewayUrl as string}/tariff/${country as string}/quoteId`, {
                        method: "POST",
                        headers: { "Content-Type": "text/plain" },
                        body: insuranceQuoteId,
                    });
                    const parsedResult: UscInsuranceQuoteType = await result.json();

                    dispatch(setInsuranceQuote(parsedResult));
                } catch (ex) {
                    Debug.error("Failed to fetch insurance quote");
                }
            };
            fetchInsuranceQuote();
        } else {
            // No quote in state, check if any quote is saved in the session.
            const insuranceSessionQuote = getInsuranceQuoteFromStorage(sessionStorageParmms, vehicleState.result!.id);
            if (insuranceSessionQuote) {
                dispatch(setInsuranceQuote(insuranceSessionQuote));
            }
        }
    }, [vehicleLoaded]);
};

export default useUscInsuranceInit;
